export default "__VITE_ASSET__C05l3tud__"